var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{staticStyle:{"min-height":"40%"},attrs:{"position":"bottom","closeable":"","round":"","close-icon":"close"},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('RecordDetail',{ref:"recordDetailRef",attrs:{"expoId":_vm.expoId,"visible":_vm.visible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }